import { FieldSettingsMap } from '@user/store/entityFormSettings/typings'
import * as React from 'react'
import { useData } from './hooks'
import Grid from '@mui/material/Grid'
import { TextFieldProps } from '@mui/material/TextField'
import { FormSection } from '@sales-center/components'
import { DensityType } from '@user/components/Opportunities/AddOpportunityPage/typings'
import { useTidalThemeActive } from '@user/features/TidalThemeToggle'
import { TargetPestSelect } from '@user/components/Formik/TargetPestSelect/TargetPestSelect'

type Props = {
  fieldNamePrefix?: string
  settingsMap: FieldSettingsMap
  spacing?: number
  textFieldProps?: TextFieldProps
}

export function TargetPestsSection(props: Props) {
  const { fieldNamePrefix = '', settingsMap, spacing } = props
  const tidalThemeActive = useTidalThemeActive()

  const { requiredTargetPests, showTargetPests } = useData({ settingsMap })

  const density: DensityType = tidalThemeActive ? 'normal' : 'compact'

  return showTargetPests ? (
    <FormSection
      label={'Target Pest(s)'}
      spacing={spacing}
      paddingBottom={4}
      maxWidth="660px"
    >
      <Grid item xs={12}>
        <TargetPestSelect
          density={density}
          name={`${fieldNamePrefix}targetPests`}
          required={requiredTargetPests}
          show={showTargetPests}
          showCheckBox
        />
      </Grid>
    </FormSection>
  ) : null
}
